<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright" style="text-align:center">Copyright © 1981 by Penelope Lively</p>
<p class="linespace">
</p><p class="copyright" style="text-align:justify">All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review. Any members of educational institutions wishing to photocopy part or all of the work for classroom use, or publishers who would like to obtain permission to include the work in an anthology, should send their inquiries to Grove/Atlantic, Inc., 841 Broadway, New York, NY 10003.</p>
<p class="linespace">
</p><p class="copyright" style="text-align:center">First published in 1981 by</p>
<p class="copyright" style="text-align:center">Doubleday and Company, Garden City, New York</p>
<p class="linespace">
</p><p class="copyright" style="text-align:center"><i>Printed in the United States of America</i></p>
<p class="linespace">
</p><p class="copyright" style="text-align:center">All characters in this book are fictitious, and any resemblance to persons living or dead is entirely coincidental.</p>
<p class="linespace">
</p><p class="copyright" style="text-align:center">Material on pages 91 and 92 from the <i>Good News Bible.</i></p>
<p class="copyright" style="text-align:center">Old Testament: Copyright © American Bible Society 1976.</p>
<p class="copyright" style="text-align:center">New Testament: Copyright © American Bible Society 1966, 1971, 1976.</p>
<p class="copyright" style="text-align:center">Extracts from the Authorized Version of the Holy Bible, which is Crown Copyright, are with permission.</p>
<p class="linespace">
</p><p class="copyright" style="text-align:center"><span class="fsc">FIRST GROVE PRESS EDITION</span></p>
<p class="linespace">
</p><p class="copyright" style="text-align:center">Library of Congress Cataloging-in-Publication Data</p>
<p class="linespace">
</p><p class="copyright" style="text-align:left">Lively, Penelope, 1933–</p>
<p class="copyright" style="text-align:left">    Judgment day / Penelope Lively.</p>
<p class="copyright" style="text-align:left">       p. cm.</p>
<p class="copyright" style="text-align:left">    ISBN 9780802197382</p>
<p class="copyright" style="text-align:left">    1. Church architecture—Conservation and restoration—Fiction.</p>
<p class="copyright" style="text-align:left">  2. Women—England—Fiction. 3. Pageants—Fiction.</p>
<p class="copyright" style="text-align:left">  4. Villages—Fiction. 5. England—Fiction. I. Title.</p>
<p class="copyright" style="text-align:left">    PR6062.I89J8 2003</p>
<p class="copyright" style="text-align:left">    823'.914—dc21                                    2003041759</p>
<p class="linespace">
</p><p class="copyright" style="text-align:center">Grove Press</p>
<p class="copyright" style="text-align:center">841 Broadway</p>
<p class="copyright" style="text-align:center">New York, NY 10003</p>
<p class="linespace">
</p><p class="copyright" style="text-align:center">03  04  05  06  07  10    9  8  7  6  5  4  3  2  1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_Copyright.vue?2c3d311d